// 仕様: アクセスログをAPIに送信する機能
// BigQueryテーブル: sso-ms365-dev.access_log.access_log_ofc_dashboard
// 注意: カラム「url」と「content」は除外すること

import { postRequest } from "../apis/axiosAction";
import { getUserInfo } from "../data/userInfo";

/**
 * アクセスログのインターフェース
 * BigQueryテーブルのスキーマに対応（urlとcontentを除く）
 */
export interface AccessLog {
  timestamp: string;          // アクセス日時（ISO8601形式）
  employee_no: string;        // 社員番号
  employee_name: string;      // 社員名
  mail_address: string;       // メールアドレス
  page_path: string;          // ページパス（例: /daily-management）
  department_code: string;    // 部署コード
  department_name: string;    // 部門名
  hq_department_code: string; // 本部所属コードOA
  hq_department_name: string; // 本部所属名OA
  job_category_code_OA: string; //職種コード
  job_category_name_OA: string; // 職種
  ip_address: string;         // IPアドレス（クライアント側では取得不可のためnullまたは空文字）
  user_agent: string;         // ユーザーエージェント（ブラウザ・OS・デバイス情報）
}

/**
 * アクセスログをAPIに送信する
 * @param pagePath ページパス
 */
export const sendAccessLog = async (
  pagePath: string,
): Promise<void> => {
  try {
    const userInfo = getUserInfo();

    // ユーザー情報が取得できない場合はログを送信しない
    if (!userInfo || !userInfo.employee_no) {
      console.warn("ユーザー情報が取得できないため、アクセスログを送信しません");
      return;
    }

    const accessLog: AccessLog = {
      timestamp: new Date().toISOString(),
      employee_no: userInfo.employee_no || "",
      employee_name: userInfo.employee_name || "",
      mail_address: userInfo.mail_address || "",
      page_path: pagePath,
      department_code: userInfo.department_code_OA || "",
      department_name: userInfo.department_name_OA || "",
      hq_department_code: userInfo.hq_department_code_OA || "",
      hq_department_name: userInfo.hq_department_name_OA || "",
      job_category_code_OA: userInfo.job_category_code_OA || "",
      job_category_name_OA: userInfo.job_category_name_OA || "",
      ip_address: "", // クライアント側では実際のIPアドレスは取得できないため空文字
      user_agent: navigator.userAgent || "", // デバイス情報（ブラウザ・OS・デバイスタイプなど）
    };

    // アクセスログAPIのエンドポイント
    const apiUrl = process.env.REACT_APP_OFC_DASHBOARD_GRAPHQL! + "/graphql";

    // GraphQL Mutation形式でアクセスログを送信
    await postRequest(
      apiUrl,
      {
        query: `mutation RegisterAccessLog($input: AccessLogInput!) {
          registerAccessLog(input: $input) {
            success
            message
          }
        }`,
        variables: {
          input: accessLog
        }
      },
      true // GraphQL形式
    );

    console.log("アクセスログを送信しました:", pagePath);
  } catch (error) {
    // エラーが発生してもユーザー体験を損なわないようにログ出力のみ
    console.error("アクセスログ送信エラー:", error);
  }
};
